import { ISpinnerStyles, IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IBarChartStyles {
  barChartRoot?: IStyle;
  barChartContainer?: IStyle;
  overlayContainer?: IStyle;
  overlayText?: IStyle;
  overlayErrorText?: IStyle;
  loadingSpinner?: IStyle;
}

export const barChartStylesDefault = (theme: IH2OTheme): Partial<IBarChartStyles> => ({
  barChartRoot: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    position: 'relative',
  },
  barChartContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    position: 'relative',
  },
  overlayContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(243, 244, 246, 0.7)',
    zIndex: 1,
  },
  overlayText: {
    fontSize: '18px',
    fontWeight: 600,
    color: theme.palette?.gray500,
  },
  overlayErrorText: {
    fontSize: '18px',
    fontWeight: 600,
    color: theme.palette?.red400,
  },
});

export const loadingSpinnerStyles = (theme: IH2OTheme): Partial<ISpinnerStyles> => ({
  circle: {
    borderTopColor: theme.palette?.primary600,
  },
  label: {
    color: theme.palette?.primary600,
  },
});
